module.exports = __webpack_public_path__ + "54b321a9b90684d91062e044f2fc7c62.jpeg";